import { Modal, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import ChangePassword from '../auth/change-password';
import ForgotPassword from '../auth/forgot-password';
import ResetPassword from '../auth/forgot-password/reset-password';
import Login from '../auth/login';
import { isOnline } from './../../actions/appAction';
import history from './../../services/history';
import Page403 from './../exception/403';
import Page404 from './../exception/404';
import Page500 from './../exception/500';
import AddOrder from './../orders/add';
import EditOrder from './../orders/edit';
import ListOrder from './../orders/list';
import SettingAccount from './../setting/setting-account';
import SettingChannel from './../setting/setting-channel';
import SettingMerchant from './../setting/setting-merchant';
import SettingPrinter from './../setting/setting-printer';
import SetttingOAauth from './../setting/setting-oauth';
import MFASettings from './../setting/mfa';
import AddOrderFromShipment from './../shipments/add-order-from-shipment';
import DetailShipment from './../shipments/detail-shipment';
import ListShipment from './../shipments/list';
import TermsAndConditions from './../terms-and-conditions';
import './styles.css';
import SwitchShipper from './../switch-shipper'
import PrivateRoute from './private_route'
import { permissions, mechantSettings } from '../../constants';
import prohibitedItems from '../setting/setting-merchant/components/prohibited-items';

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reload: false,
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            if (navigator.onLine) {
                this.props.isOnline(true)
            } else {
                this.props.isOnline(false)
            }
            this.setState({ reload: this.props.reload })
            if (this.state.reload) {
                this.setState({ reload: false })
                history.push('/orders')
            }
        }, 60000)
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div>
                <Modal
                    visible={!this.props.isOnlineValue}
                    closable={false}
                    footer={null}
                    style={{ textAlign: "center" }}
                >
                    <Spin tip="Try to connect Internet...!" />
                </Modal>
                <Router history={history}>
                    <Switch>
                        <PrivateRoute exact path="/setting/channel" component={SettingChannel} permission={permissions.EcCredentialSaveSetting}/>
                        <PrivateRoute exact path="/setting/account" component={SettingAccount} permission={permissions.UserUpdate}/>
                        <PrivateRoute exact path="/setting/merchant" component={SettingMerchant} permission={permissions.ItemNameSearchAll}/>
                        <PrivateRoute exact path="/setting/printer" component={SettingPrinter} permission={permissions.PrinterSavePrinterSetting}/>
                        <PrivateRoute exact path="/setting/oauth/:channel" component={SetttingOAauth} permission={permissions.EcCredentialSaveSetting}/>
                        <PrivateRoute exact path="/setting/mfa" component={MFASettings} permission={permissions.UserUpdate}/>
                        <PrivateRoute exact path="/forgot-password" component={ForgotPassword} />
                        <PrivateRoute exact path="/reset-password" component={ResetPassword} />
                        <PrivateRoute exact path="/change-password" component={ChangePassword} permission={permissions.UserUpdate}/>
                        <PrivateRoute exact path="/orders" component={ListOrder} />
                        <PrivateRoute exact path="/orders/add" component={AddOrder} permission={permissions.OrderCreateNewOrder}/>
                        <PrivateRoute exact path="/orders/edit" component={EditOrder} />
                        <PrivateRoute exact path="/add-order-from-shipment" component={AddOrderFromShipment} permission={permissions.OrderCreateNewOrder} />
                        <PrivateRoute exact path="/shipments/:type?" component={ListShipment} />
                        <PrivateRoute exact path="/detail-shipment" component={DetailShipment} />
                        <PrivateRoute exact path="/switch-shipper" component={SwitchShipper} permission={permissions.SwitchShipper}/>
                        <PrivateRoute exact path="/setting/merchant/prohibited/:channelActive" component={prohibitedItems} permission={permissions.ItemNameUpdateItemName} />
                        <Route exact path="/terms-and-conditions" component={TermsAndConditions} /> 
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/403" component={Page403} />
                        <Route exact path="/404" component={Page404} />
                        <Route exact path="/500" component={Page500} />
                        <Redirect from="/" to="/login" />
                    </Switch>
                </Router>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        isOnlineValue: state.appReducer.isOnline,
        reload: state.appReducer.reload
    }
}

const mapDispatchToProps = dispatch => {
    return {
        isOnline: (payload) => {
            dispatch(isOnline(payload))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App)


// WEBPACK FOOTER //
// ./src/containers/app/index.js